const padZero = (num, targetLength = 2) => {
  let str = `${num}`;
  while (str.length < targetLength) {
    str = `0${str}`;
  }
  return str;
};
export {
  padZero as p
};
